import { IPricePoliciesEntity } from '../../Services/api/price-policies/price-policies.interface'
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IProductEntity } from '../../Services/api/products/products.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


  export class ShowPricePoliciesUseCase
implements IFormUsecase<string, IPricePoliciesEntity> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    

  public async handle (
    policyId: string
  ): Promise<Result<IPricePoliciesEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.show(policyId)

      if (response.isFailure) {
        return response
      }

      const data = response.getValue()

      if(!data) return response

    
      return Result.ok(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
